import styled from "styled-components";

export const ErrorPageWrapper = styled.div`
  max-width: 600px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: fit-content;
`;

export const ErrorImg = styled.img`
  width: 100%auto;
  border-radius: 25px;
  overflow: hidden;
`;

export const HomeBtn = styled.div`
  width: 100px;
  height: 35px;
  background-color: var(--main-bg);
  position: absolute;
  bottom: -60px;
  left: 50%;
  display: flex;
  text-align: center;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
  justify-content: center;
  border-radius: 25px;
  transform: translateX(-50%);
  transition: color 0.3s ease, background-color 0.3s ease;
  :hover {
    background-color: #1f4881;
    color: #a7a0a0;
  }
  :active {
    background-color: #073f68;
  }
`;
